import { useEffect } from "react";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";
import LandingSEOBlock from "../components/LandingSEOBlock";

export default function Landing({ onBegin }) {
  useEffect(() => {
    // No-op: analytics for landing view could be added here.
  }, []);

  return (
    <motion.div
      key="landing"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-10 flex min-h-[100dvh] flex-col items-center justify-center px-6 py-16 text-center"
      data-testid="landing-screen"
    >
      <SEOHead path="/" />
      <div className="mx-auto w-full max-w-md">
        <div
          className="mb-8 font-serif text-3xl leading-none"
          style={{ color: "var(--gold)" }}
          aria-hidden
        >
          ❦
        </div>

        <p
          className="mb-6 text-xs font-medium uppercase"
          style={{ color: "var(--gold)", letterSpacing: "0.32em" }}
        >
          The Philosopher Test
        </p>

        <h1 className="font-serif text-[40px] leading-[1.08] sm:text-[52px]">
          <span style={{ color: "var(--text)" }}>Which philosopher</span>
          <br />
          <span className="italic" style={{ color: "var(--gold)" }}>
            thinks like you?
          </span>
        </h1>

        <p
          className="mx-auto mt-8 max-w-sm text-base leading-relaxed sm:text-lg"
          style={{ color: "var(--muted)" }}
        >
          Twenty situations. Your instincts. One mind from history that mirrors yours.
        </p>

        <div className="mt-14">
          <button
            data-testid="begin-test-btn"
            className="btn-primary"
            onClick={onBegin}
          >
            Begin the test
          </button>
          <p className="mt-6 text-xs" style={{ color: "var(--muted)" }}>
            <span aria-hidden>⏱</span>{" "}
            <span style={{ letterSpacing: "0.08em" }}>
              3 minutes · 20 questions · no signup
            </span>
          </p>
        </div>
      </div>
      <LandingSEOBlock />
      <Footer />
    </motion.div>
  );
}
